import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';

interface Step2FilesProps {
    formData: any;
    mainFiles: any[];
    attachedFiles: any[];
    isViewMode?: boolean;
    filePreviews: Record<string, string>;
    previewLoading: Record<string, boolean>;
    onComputerUpload: () => void;
    onCreateGoogleFile: () => void;
    onSelectTemplate?: () => void;
    onViewFile: (file: any) => void;
    onRemoveFile: (file: any) => void;
    onAttachmentUpload: () => void;
    getFileMenuItems: (file: any) => any;
    getAttachmentMenuItems: (file: any) => any;
    getIconByExtension: (ext: string) => { icon: string; color: string };
    isTemplateMode?: boolean;
    pdfGenerating?: Set<string>;
}

export const Step2Files: React.FC<Step2FilesProps> = ({
    formData,
    mainFiles,
    attachedFiles,
    isViewMode = false,
    filePreviews,
    previewLoading,
    onComputerUpload,
    onCreateGoogleFile,
    onSelectTemplate,
    onViewFile,
    onRemoveFile,
    onAttachmentUpload,
    getFileMenuItems,
    getAttachmentMenuItems,
    getIconByExtension,
    isTemplateMode = false,
    pdfGenerating = new Set()
}) => {
    const hasMainFiles = mainFiles.length > 0;

    return (
        <div className="grid">
            <div className="col-12">
                <Card title={<span className="font-bold">TỆP TÀI LIỆU ({mainFiles.length})</span>} className="shadow-1 mb-4">
                    <div className="grid mt-2">
                        {!isViewMode && (
                            <div className={hasMainFiles ? 'col-12 lg:col-7 xl:col-7 mb-3' : 'col-12 mb-3'}>
                                <div className="border-2 border-dashed border-round p-4 text-center transition-all hover:border-primary"
                                    style={{
                                        backgroundColor: 'var(--surface-variant)',
                                        borderColor: 'var(--primary-color)',
                                        height: hasMainFiles ? '350px' : '320px',
                                        minHeight: hasMainFiles ? '350px' : '320px',
                                        maxWidth: hasMainFiles ? 'none' : '760px',
                                        margin: hasMainFiles ? undefined : '0 auto',
                                        borderStyle: 'dashed'
                                    }}>
                                    <div className="flex flex-column align-items-center gap-3 h-full justify-content-center">
                                        <i className="pi pi-upload text-4xl text-blue-500"></i>
                                        <div>
                                            <p className="text-gray-700 m-0 font-medium text-sm">Thêm vào tệp của bạn từ</p>
                                        </div>
                                        <div className="grid w-full" style={{ maxWidth: hasMainFiles ? 'none' : '520px' }}>
                                            <div className={onSelectTemplate ? "col-4" : "col-6"}>
                                                <div
                                                    className="flex flex-column align-items-center gap-1 p-2 border-1 border-gray-300 border-round transition-all cursor-pointer hover:bg-white hover:shadow-2"
                                                    onClick={onComputerUpload}
                                                >
                                                    <i className="pi pi-folder text-xl text-blue-500"></i>
                                                    <span className="text-xs font-medium text-gray-700">Máy tính</span>
                                                </div>
                                            </div>
                                            <div className={onSelectTemplate ? "col-4" : "col-6"}>
                                                <div
                                                    className="flex flex-column align-items-center gap-1 p-2 border-1 border-gray-300 border-round transition-all cursor-pointer hover:bg-white hover:shadow-2"
                                                    onClick={onCreateGoogleFile}
                                                >
                                                    <i className="pi pi-file text-xl text-blue-500"></i>
                                                    <span className="text-xs font-medium text-gray-700">Soạn mới</span>
                                                </div>
                                            </div>
                                            {onSelectTemplate && (
                                                <div className="col-4">
                                                    <div
                                                        className="flex flex-column align-items-center gap-1 p-2 border-1 border-gray-300 border-round transition-all cursor-pointer hover:bg-white hover:shadow-2"
                                                        onClick={onSelectTemplate}
                                                    >
                                                        <i className="pi pi-copy text-xl text-orange-500"></i>
                                                        <span className="text-xs font-medium text-gray-700">Từ mẫu</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div>
                                            <small className="text-gray-500 text-xs">Định dạng được hỗ trợ: .pdf, .docx, .doc</small>
                                        </div>
                                        <Button
                                            label="Thêm"
                                            icon="pi pi-plus"
                                            className="p-button-sm"
                                            onClick={onComputerUpload}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {mainFiles.map((file, index) => (
                            <div key={index} className="col-12 lg:col-5 xl:col-5 mb-3">
                                <div className="card p-3 shadow-1 border-round-lg border-1 surface-border" 
                                    style={{ 
                                        backgroundColor: 'var(--surface-card)', 
                                        height: '350px',
                                        minHeight: '350px'
                                    }}>
                                    <div className="flex flex-column h-full">
                                        <div className="flex-1 mb-2 overflow-hidden" style={{ minHeight: 0 }}>
                                            <div className="border-1 border-round p-2 text-center h-full flex align-items-center justify-content-center" style={{ backgroundColor: 'var(--surface-variant)', borderColor: 'var(--surface-border)' }}>
                                                {(() => {
                                                    const fileKey = `${file.name}-${file.googleFileId || file.fileId || file.id}`;
                                                    if (previewLoading[fileKey]) return <i className="pi pi-spin pi-spinner text-2xl text-blue-500" />;
                                                    if (filePreviews[fileKey]) {
                                                        return <img src={filePreviews[fileKey]} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '4px' }} />;
                                                    }


                                                    const ic = getIconByExtension(file.extension);
                                                    return <i className={`${ic.icon} ${ic.color} text-4xl`} />;
                                                })()}

                                            </div>
                                        </div>
                                        <div className="flex-shrink-0 flex align-items-center justify-content-between gap-1 overflow-hidden" style={{ height: '32px' }}>
                                            <div className="flex align-items-center gap-2 flex-1 overflow-hidden">
                                                {(() => {
                                                    const ic = getIconByExtension(file.extension);
                                                    return <i className={`${ic.icon} ${ic.color} flex-shrink-0 text-sm`}></i>;
                                                })()}
                                                <span 
                                                    className="text-sm font-medium" 
                                                    title={file.name}
                                                    style={{ 
                                                        color: 'var(--text-color)',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        flex: 1
                                                    }}
                                                >
                                                    {file.name}
                                                </span>
                                            </div>


                                            <Menu
                                                model={getFileMenuItems(file)}
                                                popup
                                                ref={(el) => { if (el) (file as any).menuRef = el; }}
                                            />
                                            <Button
                                                icon="pi pi-ellipsis-v"
                                                className="p-button-text p-button-sm p-0"
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    (file as any).menuRef?.toggle(e);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card>

                {formData.agreementType && (
                    <Card title={<span className="font-bold">TỆP ĐÍNH KÈM ({attachedFiles.length})</span>} className="shadow-1">
                        {!isViewMode && (
                            <div className="flex justify-content-end mb-3">
                                <Button label="Thêm file đính kèm" icon="pi pi-plus" size="small" onClick={onAttachmentUpload} />
                            </div>
                        )}
                        {attachedFiles.length > 0 ? (
                            <div className="overflow-x-auto border-1 surface-border border-round">
                                <table className="w-full text-sm border-collapse text-color" style={{ minWidth: '520px' }}>
                                    <thead className="surface-200">
                                        <tr>
                                            <th className="py-3 px-2 text-center" style={{ width: '56px' }}>STT</th>
                                            <th className="p-3 text-left">Tệp đính kèm</th>
                                            <th className="p-3 text-center" style={{ width: '90px' }}>Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody className="surface-card">
                                        {attachedFiles.map((file, idx) => (
                                            <tr key={file.agreementContentId || file.fileId || file.id || `${file.name}-${idx}`} className="border-bottom-1 surface-border">
                                                <td className="py-3 px-2 text-center font-bold">{idx + 1}</td>
                                                <td className="p-3">
                                                    <span className="text-color-secondary" title={file.name || file.fileName}>
                                                        {file.name || file.fileName || 'Tệp đính kèm'}
                                                        {file.uploading && <i className="pi pi-spin pi-spinner ml-2" />}
                                                    </span>
                                                </td>
                                                <td className="p-3 text-center">
                                                    <Menu
                                                        model={getAttachmentMenuItems(file)}
                                                        popup
                                                        ref={(el) => { if (el) (file as any).attachmentMenuRef = el; }}
                                                    />
                                                    <Button
                                                        icon="pi pi-ellipsis-v"
                                                        className="p-button-text p-button-secondary p-button-sm"
                                                        disabled={!!file.uploading || pdfGenerating.has(file.fileId || file.googleFileId || file.id)}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            (file as any).attachmentMenuRef?.toggle(e);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="p-4 text-center text-gray-500">Chưa có file đính kèm.</div>
                        )}
                    </Card>
                )}
            </div>
        </div>
    );
};
